import "./attendanceStyle.css";
import { useCallback, useEffect, useState, useRef } from "react";
import { Col, Form, Row, Button as CustomButton } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { Link, useNavigate } from "react-router-dom";

import Switch from "@mui/material/Switch";
import { MdClear } from "react-icons/md";

import Dropdown from "react-bootstrap/Dropdown";

import ButtonCom from "../../components/button/button";
import { useGlobalToast } from '../../stopOldToastGlobally.js';
import TableSkeleton from "../../components/table/TableSkeleton.js";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import Widgets from "../../components/Widgets";

import dayjs from "dayjs";
import {
  getCapitalizeWord,
  getCurrentDate,
  getFormattedUsers,
  downloadCSV,
  getAttendanceFormattedData,
  flattenObject,
  csvDataWithNestedObject,
  getInitials,
  getInitialColor,
  getDateWithMonthName,
  downloadAsPdf,
  generateForm22Doc,
  exportToTrackerExcel,
  trackerDataFormat,
  downloadForm22Excel,
  getMonthlyAttendanceInExcelFormat,
  formatDateToMonthYear,
} from "../../services/commonServices";
import {
  fetchBranchData,
  initBranchState,
} from "../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../redux/slices/departmentSlice";
import {
  fetchData as fetchShiftData,
  initShiftState,
} from "../../redux/slices/shiftsSlice";
import {
  fetchDailyAttData,
  initDailyAttState,
} from "../../redux/slices/dailyAttendanceSlice";
import {
  commonGetData,
  commonSaveData,
  initCommonState,
} from "../../redux/slices/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  employeeAttendanceDashboardPath,
  dailyAttendancePath,
  editAttendancePath,
  createForm22PAth,
  getForm22Path,
} from "../../services/config";
import CustomPagination from "../../components/CustomPagination";
import { HasPermission } from "../../services/hasPermission";
import Form_22 from "../../components/Excel/Form_22.js";

const MonthlyAttendance = () => {
  const customToast = useGlobalToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tomorrow = dayjs().add(1, "day");
  const user = JSON.parse(localStorage.getItem("user_data")) || null;

  const branchState = useSelector((state) => state.branch);
  const departmentState = useSelector((state) => state.department);
  const shiftState = useSelector((state) => state.shift);
  const dailyAttendanceState = useSelector((state) => state.dailyAttendance);
  const commonStore = useSelector((state) => state.common);

  const [currentDate, setCurrentDate] = useState("");
  const [branchId, setBranchId] = useState("");
  const [shiftId, setShiftId] = useState("");
  const [departId, setDepartId] = useState("");
  const [dailySummary, setDailySummary] = useState({});
  const [dailyAttendance, setDailyAttendance] = useState([]);
  const [filteredAttendance, setFilteredAttendance] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showAttendanceType, setShowAttendanceType] = useState(false);
  const [filterByValue, setFilterByValue] = useState("");
  const [editAttValue, setEditAttValue] = useState("");
  const [attendanceType, setAttendanceType] = useState({});
  const [maxMonth, setMaxMonth] = useState(null);
  const [formType, setFormType] = useState("");
  const [gridApi, setGridApi] = useState(null);
  const [isToggle, setIsToggle] = useState(true);
  const [validated, setValidated] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isDownload, setIsDownload] = useState(false);
  const [fileFormat, setFileFormat] = useState("");
  const [nStaffId, setNStaffId] = useState("");
  const [nStaffName, setNStaffName] = useState("");
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const gridRef = useRef(null);

  const [form22State, setForm22State] = useState({
    contractorName: "",
    contractorAddress: "",
    natureOfWork: "",
    locationOfWork: "",
    establishmentName: "",
    establishmentAddress: "",
    fromDate: "",
    toDate: "",
    wagesPeriod: "2025/08/01 - 2025/08/10",
    principalEmployerName: "",
    principalEmployerAddress: "",
  });

  const date_1 = new Date();
  const year_1 = date_1.getFullYear();
  const month_1 = String(date_1.getMonth() + 1).padStart(2, "0");

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getAttendance = useCallback((date, branchId, shiftId, departmentId) => {
    dispatch(
      fetchDailyAttData({
        path: employeeAttendanceDashboardPath,
        data: {
          userId: user.user_id,
          selectedDate: date,
          branchId: branchId,
          shiftId: shiftId,
          departmentId: departmentId,
        },
      })
    );
  }, []);

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setMaxMonth(`${year}-${month}`);
    setCurrentDate(`${year}-${month}`);
    getAttendance(`${year}-${month}-01`);
  }, []);

  const handleAttChange = ({ target: { value, name } }) => {
    if (name === "shiftId") {
      setShiftId(value);
      getAttendance(currentDate + "-01", branchId, value, departId);
      return;
    }
    if (name === "branchId") {
      setBranchId(value);
      getAttendance(currentDate + "-01", value, shiftId, departId);
      return;
    }
    if (name === "departId") {
      setDepartId(value);
      getAttendance(currentDate + "-01", branchId, shiftId, value);
      return;
    }
  };

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      setBranchList(branchState.brnGetData);
      dispatch(initBranchState());
    }

    if (departmentState.depGetSuccess) {
      setDepartmentList(departmentState.depGetData);
      dispatch(initDepartState());
    }

    if (shiftState.shiftGetSuccess) {
      setShiftList(shiftState.shiftGetData);
      dispatch(initShiftState());
    }

    if (dailyAttendanceState.dailyAttGetSuccess) {
      const { status, data } = dailyAttendanceState.dailyAttGetData;
      if (status === true || status === "true") {
        if (searchQuery) {
          searchEmployees(searchQuery, data.staffAttendanceData);
        } else {
          setDailySummary(data.staffAttendanceData);
          setDailyAttendance(data.staffAttendanceData);
          setFilteredAttendance(data.staffAttendanceData);
          let path = getForm22Path + user.user_id;
          dispatch(commonGetData(path));
          dispatch(fetchBranchData(user.user_id));
          dispatch(fetchDepartmentData(user.user_id));
          dispatch(fetchShiftData(user.user_id));
        }
      } else {
        setDailySummary({});
        setDailyAttendance([]);
        setFilteredAttendance([]);
      }
      dispatch(initDailyAttState());
    }

    if (dailyAttendanceState.dailyAttGetError) {
      setDailySummary({});
      setDailyAttendance([]);
      setFilteredAttendance([]);
      dispatch(initDailyAttState());
    }

    if (commonStore.commonSuccess) {
      customToast.success("Attendance updated successfully");
      setEditAttValue("");
      setAttendanceType({});
      setShowAttendanceType(false);
      getAttendance(currentDate + "-01");
      dispatch(initCommonState());
    }
    if (commonStore.commonError) {
        customToast.error(commonStore.commonMessage || "Something went wrong"); 
      setShowAttendanceType(false);
      dispatch(initCommonState());
    }

    if (commonStore.commonGetSuccess) {
      const data = commonStore.commonGetData;
      setForm22State((pre) => ({
        ...pre,
        contractorName: data.contractorName,
        contractorAddress: data.contractorAddress,
        natureOfWork: data.natureOfWork,
        locationOfWork: data.locationOfWork,
        establishmentName: data.establishmentName,
        establishmentAddress: data.establishmentAddress,
        wagesPeriod: data.wagesPeriod,
        principalEmployerName: data.principalEmployerName,
        principalEmployerAddress: data.principalEmployerAddress,
      }));
      dispatch(initCommonState());
    }
  }, [branchState, departmentState, shiftState, dailyAttendanceState, commonStore, dispatch]);

  const handleShowAttendance = (data) => {
    setNStaffId(data.data.staffId);
    setNStaffName(data.data.staffName);
  };

  const handleShowHide = () => {
    if (showAttendanceType) {
      setShowAttendanceType(!showAttendanceType);
    }
  };

  const onSelectionChanged = useCallback(() => {
    const selectedNodes = gridRef.current.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRowsData(selectedData);
  }, []);

  // ── Column Definitions ────────────────────────────────────
  const columnDefs = [
    {
      headerName: "",
      field: "checkbox",
      checkboxSelection: (params) => !isToggle,
      headerCheckboxSelection: !isToggle ? true : false,
      headerCheckboxSelectionFilteredOnly: false,
      width: 40,
      suppressMenu: true,
      suppressSorting: true,
      pinned: "left",
    },
    {
      headerName: "Employee ID",
      width: 120,
      pinned: "left",
      suppressRowClickSelection: true,
      cellRenderer: (rowData) => (
        <span style={{
          fontFamily: "'Outfit', sans-serif",
          fontSize: "12px",
          color: "#9998A2",
          fontWeight: 400,
        }}>
          {rowData.data.employeeId}
        </span>
      ),
    },
    {
      headerName: "Staff Name",
      width: 240,
      pinned: "left",
      cellRenderer: (rowData) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
            height: "100%",
          }}
          onClick={() => handleShowAttendance(rowData)}
        >
          {/* Avatar */}
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: getInitialColor(rowData.data.staffName),
              color: "#FFFFFF",
              fontWeight: 600,
              fontSize: "12px",
              fontFamily: "'Outfit', sans-serif",
              flexShrink: 0,
            }}
          >
            {getInitials(rowData.data.staffName)}
          </div>
          {/* Name */}
          <span className="link-hover">{rowData.data.staffName}</span>
        </div>
      ),
    },
    {
      headerName: "Phone Number",
      width: 140,
      cellRenderer: (rowData) => (
        <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: "13px", color: "#9998A2" }}>
          {rowData.data.mobileNumber}
        </span>
      ),
    },
    {
      headerName: "Job Title",
      field: "jobTitle",
      width: 140,
    },
    {
      headerName: "Present",
      field: "attendanceSummary.Present",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 90,
      cellRenderer: (p) => (
        <span style={{ color: "#22C55E", fontWeight: 600, fontFamily: "'Outfit', sans-serif" }}>
          {p.value ?? "—"}
        </span>
      ),
    },
    {
      headerName: "Absent",
      field: "attendanceSummary.Absent",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 90,
      cellRenderer: (p) => (
        <span style={{ color: "#EF4444", fontWeight: 600, fontFamily: "'Outfit', sans-serif" }}>
          {p.value ?? "—"}
        </span>
      ),
    },
    {
      headerName: "Half Day",
      valueGetter: (params) => params.data.attendanceSummary?.["Half Day"],
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 90,
    },
    {
      headerName: "Week Off",
      field: "attendanceSummary.WeekOff",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 90,
    },
    {
      headerName: "Holiday",
      field: "attendanceSummary.Holiday",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 90,
    },
    {
      headerName: "Paid Leave",
      valueGetter: (params) => params.data.attendanceSummary?.["Paid Leave"],
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 100,
    },
    {
      headerName: "Unpaid Leave",
      valueGetter: (params) => params.data.attendanceSummary?.["Un Paid Leave"],
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 110,
    },
    {
      headerName: "OT Working Day",
      valueGetter: (params) => params.data.attendanceSummary?.["Un Paid Leave"],
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 120,
    },
    {
      headerName: "OT Week Off",
      valueGetter: (params) => params.data.attendanceSummary?.["Un Paid Leave"],
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 110,
    },
    {
      headerName: "OT Holiday",
      valueGetter: (params) => params.data.attendanceSummary?.["Un Paid Leave"],
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 100,
    },
    {
      headerName: "Late Coming",
      valueGetter: (params) => params.data.attendanceSummary?.["Late CheckIn"],
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 110,
      cellRenderer: (p) => (
        <span style={{ color: "#F59E0B", fontFamily: "'Outfit', sans-serif" }}>
          {p.value ?? "—"}
        </span>
      ),
    },
    {
      headerName: "Early Leaving",
      valueGetter: (params) => params.data.attendanceSummary?.["Early CheckOut"],
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: 110,
      cellRenderer: (p) => (
        <span style={{ color: "#F59E0B", fontFamily: "'Outfit', sans-serif" }}>
          {p.value ?? "—"}
        </span>
      ),
    },
  ];

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const handleDateChange = (value) => {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setCurrentDate(`${year}-${month}`);
    getAttendance(`${year}-${month}-01`, branchId, shiftId);
  };

  const handleClose = () => setIsShow(false);

  const filterEmployee = () => {
    const filteredEmployees =
      dailyAttendance?.filter(
        (v) => v.status?.toLowerCase().trim() === filterByValue.toLowerCase().trim()
      ) || [];
    setFilteredAttendance(filteredEmployees);
    setIsShow(false);
  };

  const searchEmployees = (val, dataList) => {
    setSearchQuery(val);
    const filteredEmployees =
      dataList?.filter(
        (v) =>
          v.staffName.toLowerCase().includes(val.toLowerCase()) ||
          v.employeeId.toLowerCase().includes(val.toLowerCase())
      ) || [];
    setFilteredAttendance(filteredEmployees);
    setDailyAttendance(dailyAttendance);
  };

  const handleDownloadOpen = () => setIsDownload(true);
  const handleDownloadClose = () => {
    setIsDownload(false);
    setFileFormat("");
  };
  const handleDownloadAction = (formType) => {
     if (!dailyAttendance || dailyAttendance.length === 0) {
    customToast.warning("No data to export");  // ✅
    return;
  }
    setFormType(formType);
    handleDownloadOpen();
  };

  const handleForm22InputChange = ({ target: { name, value } }) => {
    setForm22State((pre) => ({ ...pre, [name]: value }));
  };

  const preSubmit = () => {
    const elem = document.querySelector("#submitForm");
    if (elem) elem.click();
  };

  const downloadFileInFormat = (e) => {
    const data =
      !isToggle && selectedRowsData?.length ? selectedRowsData : dailyAttendance;
    const initDateArray = data[0].monthlyAttendance;
    const formDownloadDate = formatDateToMonthYear(initDateArray[0].date);

    if (formType === "form_22") {
      const form = e.currentTarget;
      e.preventDefault();
      e.stopPropagation();
      if (form.checkValidity() === false) {
        setValidated(true);
      } else {
        handleDownloadClose();
        const headerData = {
          userId: user.user_id,
          contractorName: form22State.contractorName,
          contractorAddress: form22State.contractorAddress,
          natureOfWork: form22State.natureOfWork,
          locationOfWork: form22State.locationOfWork,
          establishmentName: form22State.establishmentName,
          establishmentAddress: form22State.establishmentAddress,
          wagesPeriod: currentDate,
          principalEmployerName: form22State.principalEmployerName,
          principalEmployerAddress: form22State.principalEmployerAddress,
          employeeData: getMonthlyAttendanceInExcelFormat(data),
        };
        const dataForm22 = { path: createForm22PAth, data: headerData };
        dispatch(commonSaveData(dataForm22));
        if (fileFormat === "excel") {
          downloadForm22Excel(headerData, initDateArray, formDownloadDate, "xlsx");
        } else if (fileFormat === "csv") {
          downloadForm22Excel(headerData, initDateArray, formDownloadDate, "csv");
        } else {
          customToast.info("This feature is not available for now. It will be coming soon.");
        }
        setValidated(false);
      }
    } else {
      handleDownloadClose();
      if (fileFormat === "excel") {
        exportToTrackerExcel(trackerDataFormat(data), formDownloadDate);
      } else if (fileFormat === "csv") {
        downloadCSV(trackerDataFormat(data), `Attendance_Tracker_Report_${formDownloadDate}.csv`);
      } else {
        customToast.info("This feature is not available for now. It will be coming soon.");
      }
    }
  };

  const clearFilter = () => {
    getAttendance(currentDate, "", "", "");
    setCurrentDate(`${year_1}-${month_1}`);
    setSearchQuery("");
    setBranchId("");
    setShiftId("");
    setDepartId("");
  };

  // ✅ ONLY CHANGE: replaced hidden <Link> with useNavigate
  // Old code used: <Link to={`#monthly-attendance-report?staffId=...`}>
  // New code uses navigate() directly when nStaffId is set
  useEffect(() => {
    if (nStaffId) {
      navigate(
        `/attendance/monthly-attendance-report?staffId=${nStaffId}&staffName=${encodeURIComponent(nStaffName)}&date=${currentDate}`
      );
    }
  }, [nStaffId, nStaffName]);

  const hasActiveFilter =
    searchQuery ||
    currentDate !== `${year_1}-${month_1}` ||
    shiftId ||
    departId ||
    branchId;

  // ── Render ─────────────────────────────────────────────────
  return (
    <div className="mt-4">
      {/* ✅ Hidden <Link> removed — navigation now handled by useNavigate above */}

      

      {/* ── Filter Bar ── */}
      <Form className="d-flex align-items-center justify-content-start gap-3 mt-2">
        {/* Search */}
        <Form.Group>
          <Form.Control
            name="searchQuery"
            value={searchQuery}
            onChange={(e) => searchEmployees(e.target.value, dailyAttendance)}
            className="universal-input-one"
            placeholder="Search by Employee Name & ID"
            style={{ width: "250px" }}
          />
        </Form.Group>

        {/* Month picker */}
        <Form.Group>
          <Form.Control
            type="month"
            value={currentDate}
            max={maxMonth}
            onChange={(e) => handleDateChange(e.target.value)}
            className="universal-input-one"
            style={{ width: "160px" }}
          />
        </Form.Group>

        {/* Branch */}
        <Form.Group>
          <Form.Select
            value={branchId}
            name="branchId"
            onChange={handleAttChange}
            className="universal-input-one"
            style={{ width: "160px" }}
          >
            <option value="">Select Branch</option>
            {branchList.map((branch) => (
              <option key={branch.branchId} value={branch.branchId}>
                {branch.branch_name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {/* Shift */}
        <Form.Group>
          <Form.Select
            value={shiftId}
            name="shiftId"
            onChange={handleAttChange}
            className="universal-input-one"
            style={{ width: "160px" }}
          >
            <option value="">Select Shift</option>
            {shiftList.map((shift) => (
              <option key={shift.shiftId} value={shift.shiftId}>
                {shift.shiftName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {/* Department */}
        <Form.Group>
          <Form.Select
            value={departId}
            name="departId"
            onChange={handleAttChange}
            className="universal-input-one"
            style={{ width: "160px" }}
          >
            <option value="">Select Department</option>
            {departmentList.map((dep) => (
              <option key={dep.departmentId} value={dep.departmentId}>
                {dep.department_name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {/* Clear */}
        {hasActiveFilter && (
          <Form.Group>
            <button type="button" className="clear" onClick={clearFilter}>
              <MdClear /> Clear
            </button>
          </Form.Group>
        )}

        {/* Toggle */}
        <Switch
          name="isToggle"
          checked={isToggle}
          onChange={(event) => setIsToggle(event.target.checked)}
          inputProps={{ "aria-label": "controlled" }}
        />
      </Form>

      {/* ── Table ── */}
      <div
        className="ag-theme-quartz custom-grid mt-2"
        style={{ height: "calc(100vh - 280px)", width: "100%" }}
        onClick={handleShowHide}
      >
        {dailyAttendanceState.dailyAttGetLoading ? (
          <TableSkeleton />
        ) : (
          <AgGridReact
            rowHeight={52}
            rowData={Array.isArray(filteredAttendance) ? filteredAttendance : []}
            columnDefs={columnDefs}
            pagination={true}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
            suppressRowClickSelection={true}
            onGridReady={onGridReady}
            ref={gridRef}
            rowSelection="multiple"
            onSelectionChanged={onSelectionChanged}
          />
        )}
      </div>

      {/* ── Pagination + Download Row ── */}
      <div className="d-flex align-items-center justify-content-between custom-pagination">
        {gridApi && <CustomPagination gridApi={gridApi} />}

        {HasPermission("Monthly Attendance", "export") && (
          <Dropdown>
            <Dropdown.Toggle
              variant="success"
              id="dropdown-basic"
              className="universal-btn height_35"
              style={{ width: "140px" }}
            >
              Download
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDownloadAction("form_22")}>
                Form 22
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleDownloadAction("tracker")}>
                Attendance Tracker
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>

      {/* ── Filter Dialog ── */}
      <Dialog
        open={isShow}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Filter Employee by Status
        </DialogTitle>
        <DialogContent />
        <DialogActions>
          <Button
            onClick={handleClose}
            style={{
              backgroundColor: "#2D2A45",
              color: "#E3E2EB",
              fontFamily: "'Outfit', sans-serif",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={filterEmployee}
            style={{
              backgroundColor: "#8660F8",
              color: "#FFFFFF",
              fontFamily: "'Outfit', sans-serif",
            }}
            autoFocus
          >
            Apply Filter
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Download Dialog ── */}
      <Dialog
        open={isDownload}
        maxWidth="xs"
        fullWidth
        onClose={handleDownloadClose}
        aria-labelledby="download-dialog-title"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleDownloadClose}>✕</span>
            <span className="title">
              {formType === "form_22" ? "Form 22" : "Attendance Tracker"}
            </span>
          </div>
          <button
            className="universal-btn"
            style={{ padding: "7px 16px", fontSize: "12px" }}
            onClick={formType === "form_22" ? preSubmit : downloadFileInFormat}
          >
            Download
          </button>
        </DialogTitle>

        <DialogContent>
          {formType === "form_22" ? (
            <Form noValidate validated={validated} onSubmit={downloadFileInFormat}>

              <Form.Group className="mt-2">
                <Form.Label className="color-white">Contractor Name</Form.Label>
                <Form.Control
                  className="universal-input-one"
                  name="contractorName"
                  value={form22State.contractorName}
                  placeholder="Enter Contractor Name"
                  onChange={handleForm22InputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid name.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label className="color-white">Contractor Address</Form.Label>
                <Form.Control
                  className="universal-input-one height_100"
                  as="textarea"
                  rows={3}
                  name="contractorAddress"
                  value={form22State.contractorAddress}
                  placeholder="Enter Contractor Address"
                  onChange={handleForm22InputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid address.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label className="color-white">Nature of Work</Form.Label>
                <Form.Control
                  className="universal-input-one"
                  name="natureOfWork"
                  value={form22State.natureOfWork}
                  placeholder="Enter Nature of Work"
                  onChange={handleForm22InputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid nature of work.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label className="color-white">Location of Work</Form.Label>
                <Form.Control
                  className="universal-input-one height_100"
                  as="textarea"
                  rows={3}
                  name="locationOfWork"
                  value={form22State.locationOfWork}
                  placeholder="Enter Location of Work"
                  onChange={handleForm22InputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid work location.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label className="color-white">Establishment Name</Form.Label>
                <Form.Control
                  className="universal-input-one"
                  name="establishmentName"
                  value={form22State.establishmentName}
                  placeholder="Enter Establishment Name"
                  onChange={handleForm22InputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid name.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label className="color-white">Establishment Address</Form.Label>
                <Form.Control
                  className="universal-input-one height_100"
                  as="textarea"
                  rows={3}
                  name="establishmentAddress"
                  value={form22State.establishmentAddress}
                  placeholder="Enter Establishment Address"
                  onChange={handleForm22InputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid address.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label className="color-white">Principal Employer Name</Form.Label>
                <Form.Control
                  className="universal-input-one"
                  name="principalEmployerName"
                  value={form22State.principalEmployerName}
                  placeholder="Enter Principal Employer Name"
                  onChange={handleForm22InputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid name.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label className="color-white">Principal Employer Address</Form.Label>
                <Form.Control
                  className="universal-input-one height_100"
                  as="textarea"
                  rows={3}
                  name="principalEmployerAddress"
                  value={form22State.principalEmployerAddress}
                  placeholder="Enter Principal Employer Address"
                  onChange={handleForm22InputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid address.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label className="color-white">File Format</Form.Label>
                <Form.Select
                  onChange={(e) => setFileFormat(e.target.value)}
                  className="universal-input-one"
                  required
                >
                  <option value="">Select File Format</option>
                  <option value="excel">Excel (.xlsx)</option>
                  <option value="csv">CSV</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please select a file format.
                </Form.Control.Feedback>
              </Form.Group>

              <button type="submit" style={{ display: "none" }} id="submitForm">
                submit
              </button>
            </Form>
          ) : (
            <Form.Group className="mt-2">
              <Form.Label className="color-white">File Format</Form.Label>
              <Form.Select
                onChange={(e) => setFileFormat(e.target.value)}
                className="universal-input-one"
                required
              >
                <option value="">Select File Format</option>
                <option value="excel">Excel (.xlsx)</option>
                <option value="csv">CSV</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Please select a file format.
              </Form.Control.Feedback>
            </Form.Group>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MonthlyAttendance;